import type React from 'react';
import { useEffect } from 'react';

export const useScrollVisibilityHandler = (
  refScrollElement: React.MutableRefObject<HTMLElement>,
  onScrollVisibleChange: (isScrollVisible: boolean) => void
) => {
  useEffect(() => {
    let isScrollVisible = false;

    const handleScroll = () => {
      const refScrollVisible = refScrollElement.current.scrollTop > 0;
      if (isScrollVisible !== refScrollVisible) {
        isScrollVisible = refScrollVisible;
        onScrollVisibleChange(isScrollVisible);
      }
    };

    const scrollElement = refScrollElement.current;

    if (scrollElement) {
      scrollElement.addEventListener('scroll', handleScroll);
    }

    return () => {
      if (scrollElement) {
        scrollElement.removeEventListener('scroll', handleScroll);
      }
    };
  }, []);
};
